import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import * as ROUTES from '../constants/routes';
import useFirebase from './Firebase';
import {
  TextField,
  makeStyles,
  Button,
  Container,
  CssBaseline,
  Avatar,
  Typography,
  InputAdornment,
  IconButton,
  Grid,
  OutlinedInput,
  InputLabel,
  FormControl,
  FormControlLabel,
  Checkbox
} from '@material-ui/core';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { SignInLink } from './SignIn';
import LoadingScreen from './Loading';

const useStyles = makeStyles(theme => ({
  error: {
    color: theme.palette.error.main
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  }
}));

const SignUpPage = () => {
  const classes = useStyles();
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign Up
        </Typography>
        <SignUpForm />
        <Grid container>
          <SignInLink />
        </Grid>
      </div>
    </Container>
  );
};

const SignUpForm = () => {
  const classes = useStyles();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const firebase = useFirebase();
  const history = useHistory();

  const handleSubmit = e => {
    setLoading(true);
    console.log('signing up user');
    firebase
      .doCreateUserWithEmailAndPassword(email, password)
      .then(authUser => {
        console.log('signup complete');
        firebase.logEvent('signup');
        return firebase.user(authUser.user.uid).set({
          email,
          uid: authUser.user.uid,
          role: 'user',
          plan: 'free'
        });
      })
      .then(() => {
        setEmail('');
        setPassword('');
        setLoading(false);
        history.push(ROUTES.TRANSCRIPTION_LIST);
      })
      .catch(err => {
        setError(err);
        setEmail('');
        setPassword('');
        setLoading(false);
      });
    e.preventDefault();
  };

  const isInvalid = password === '' || email === '';

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = event => {
    event.preventDefault();
  };

  return (
    <form className={classes.form} onSubmit={handleSubmit}>
      {loading && <LoadingScreen />}
      <TextField
        variant="outlined"
        margin="normal"
        required
        fullWidth
        autoFocus
        id="email"
        label="Email Address"
        autoComplete="email"
        name="email"
        value={email}
        onChange={e => setEmail(e.target.value)}
        type="text"
      ></TextField>
      <FormControl className={classes.form} variant="outlined">
        <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
        <OutlinedInput
          variant="outlined"
          required
          label="Password"
          fullWidth
          id="outlined-adornment-password"
          type={showPassword ? 'text' : 'password'}
          value={password}
          onChange={e => setPassword(e.target.value)}
          autoComplete="new-password"
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          }
          labelWidth={70}
        />
      </FormControl>
      <FormControlLabel
        className={classes.form}
        control={<Checkbox required value="" color="primary" />}
        label={
          <>
            By signin up you accept our{' '}
            <a href={'https://autote.app/tos'}>Terms of Service</a> and{' '}
            <a href={'https://autote.app/dataSecurity'}>Privacy Policy</a>
          </>
        }
      />
      {error && <p className={classes.error}>{error.message}</p>}
      <Button
        variant="contained"
        fullWidth
        color="primary"
        disabled={isInvalid}
        type="submit"
        className={classes.submit}
      >
        Sign Up
      </Button>
    </form>
  );
};

const SignUpLink = () => (
  <Grid item>
    <Link to={ROUTES.SIGN_UP}>{"Don't have an account? Sign Up"}</Link>
  </Grid>
);

export default SignUpPage;

export { SignUpForm, SignUpLink };
